export const trustIconsForEWHnl = [
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-anvr.ashx?la=nl-nl&h=45&w=77',
    altText: 'ANVR',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-sgr.ashx?la=nl-nl&h=45&w=77',
    altText: 'SGR',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-calamiteiten-fonds.ashx?la=nl-nl&h=45&w=77',
    altText: 'Calamiteitenfonds',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-thuiswinkel.ashx?la=nl-nl&h=45&w=77',
    altText: 'Thuiswinkel Waarborg',
  },
]

export const trustIconsForEWHbe = [
  {
    image: '/-/media/01_eliza-was-here-nl-be/footer/abto-logo.ashx?h=45&w=77&la=nl-be',
    altText: 'ABTO',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-sgr.ashx?la=nl-nl&h=45&w=77',
    altText: 'SGR',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-calamiteiten-fonds.ashx?la=nl-nl&h=45&w=77',
    altText: 'Calamiteitenfonds',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/archief/huisstijl/zekerheden-thuiswinkel.ashx?la=nl-nl&h=45&w=77',
    altText: 'Thuiswinkel Waarborg',
  },
  {
    image: '/-/media/01_eliza-was-here-nl-be/footer/ecommerce_europe_trustmark.ashx?h=45&w=77&la=nl-be',
    altText: 'Ecommerce Europe',
  },
]
